import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Select from 'react-select'
import { PERFIL_ADMIN } from '../security/securityContext'
import Autorizacao from '../security/Autorizacao'
import ModalAlterarSenhaUsuario from './usuario/empresa/ModalAlterarSenhaUsuario'
import buscarEmpresas from '../actions/empresa/buscarEmpresas'
import alterarEmpresaSelecionada from '../actions/empresa/alterarEmpresaSelecionada'
import limparViagens from '../actions/viagem/limpaViagens'

const GRUPOS = [
  {
    label: 'Tickets',
    items: [
      { icon: 'person',               label: 'Usuários',                    route: '/painel-usuarios' },
      { icon: 'directions_bus',       label: 'Veículos',                    route: '/painel-veiculos' },
      { icon: 'local_atm',            label: 'Valores',                     route: '/painel-valores' },
      { icon: 'store_mall_directory', label: 'Agências',                    route: '/painel-agencia' },
      { icon: 'confirmation_number',  label: 'Passagens Vendidas',          route: '/painel-vendas' },
      { icon: 'autorenew',            label: 'Remarcar/Cancelar passagem',  route: '/painel-remarcacao' },
      { icon: 'local_shipping',       label: 'Encomendas Vexado Express',   route: '/menu-encomendas' },
    ]
  },
  {
    label: null,
    items: [
      { icon: 'monetization_on',   label: 'Vender Passagem',     route: '/painel-destinos' },
      { icon: 'business_center',   label: 'Bagagem Extra',        route: '/menu-bagagem' },
      { icon: 'payment',           label: 'Fechamento de Caixa',  route: '/menu-fechamento-caixa' },
    ]
  },
  {
    label: null,
    items: [
      { icon: 'device_hub',      label: 'Rotas',       route: '/painel-rotas' },
      { icon: 'compare_arrows',  label: 'Trechos',     route: '/painel-trechos' },
      { icon: 'directions',      label: 'Itinerários', route: '/menu-itinerario' },
    ]
  },
  {
    label: null,
    items: [
      { icon: 'insert_chart',        label: 'Relatórios',          route: '/menu-relatorio' },
      { icon: 'dvr',                 label: 'CT-e OS',              route: '/menu-cteos' },
      { icon: 'business',            label: 'Configurações BPe',
        routeFn: (emp) => emp
          ? `/painel-configuracao-bpe?codigoEmpresa=${emp.id}&habilitadaBPe=${emp.habilitadoBpe}&pagina=gestao`
          : '/painel-configuracao-bpe'
      },
      { icon: 'receipt',             label: 'Centro de Custo',     route: '/painel-centro-custo' },
      { icon: 'stars',               label: 'Adesão de pontos',    route: '/menu-adesao-pontos-empresa' },
      { icon: 'confirmation_number', label: 'Configuração Bilhete',
        routeFn: (emp) => emp
          ? `/painel-configuracao-bilhete?codigoEmpresa=${emp.id}&pagina=gestao`
          : '/painel-configuracao-bilhete'
      },
    ]
  },
]

export class PaginaPrincipalGestao extends Component {
  constructor (props) {
    super(props)
    this.state = { empresaSelecionada: null }
    this.handleNavegar = this.handleNavegar.bind(this)
  }

  componentDidMount () {
    this.props.buscarEmpresas()
  }

  handleSelecionarEmpresa (option) {
    if (!option) {
      this.setState({ empresaSelecionada: null })
      return
    }
    const empresa = this.props.empresas.find(e => e.id === option.value)
    this.setState({ empresaSelecionada: empresa || null })
  }

  handleNavegar (item) {
    const { empresaSelecionada } = this.state
    if (empresaSelecionada) {
      this.props.alterarEmpresaSelecionada(empresaSelecionada)
    }
    if (item.route === '/painel-destinos') {
      this.props.limparViagens()
    }
    const rota = item.routeFn
      ? item.routeFn(empresaSelecionada)
      : item.route
    this.props.history.push(rota)
  }

  opcoesEmpresas () {
    const { empresas } = this.props
    if (!empresas || !empresas.length) return []
    return empresas.map(e => ({
      label: e.nomeFantasia || e.nome,
      value: e.id
    }))
  }

  renderGrupo (grupo, idx) {
    const { empresaSelecionada } = this.state
    const semEmpresa = !empresaSelecionada

    return (
      <div key={idx} className="vx-grl-grupo">
        {grupo.label && (
          <div className="vx-grl-grupo-label">{grupo.label}</div>
        )}
        <div className="vx-grl-grupo-grid">
          {grupo.items.map(item => (
            <button
              key={item.label}
              className={`vx-grl-card${semEmpresa ? ' vx-grl-card--disabled' : ''}`}
              onClick={() => this.handleNavegar(item)}
              title={semEmpresa ? 'Selecione uma empresa primeiro' : item.label}
            >
              <div className="vx-grl-card__icon">
                <i className="material-icons">{item.icon}</i>
              </div>
              <span className="vx-grl-card__label">{item.label}</span>
            </button>
          ))}
        </div>
      </div>
    )
  }

  render () {
    const { empresaSelecionada } = this.state
    const opcoes = this.opcoesEmpresas()

    return (
      <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
        <div className="vx-grl-page">

          {/* Cabeçalho */}
          <div className="vx-grl-header">
            <div className="vx-grl-header__icon">
              <i className="material-icons">admin_panel_settings</i>
            </div>
            <div>
              <h2 className="vx-grl-header__title">Painel Gerencial</h2>
              <p className="vx-grl-header__sub">Selecione uma empresa e acesse suas funcionalidades</p>
            </div>
          </div>

          {/* Seletor de empresa */}
          <div className="vx-grl-empresa-selector">
            <label className="vx-grl-empresa-label">
              <i className="material-icons">business</i>
              Empresa
            </label>
            <div className="vx-grl-empresa-select-wrap">
              <Select
                options={opcoes}
                value={empresaSelecionada
                  ? { label: empresaSelecionada.nomeFantasia || empresaSelecionada.nome, value: empresaSelecionada.id }
                  : null}
                onChange={opt => this.handleSelecionarEmpresa(opt)}
                placeholder="Selecione a empresa..."
                isClearable
                noOptionsMessage={() => 'Nenhuma empresa encontrada'}
                styles={{
                  control: base => ({
                    ...base,
                    minHeight: 42,
                    fontSize: 14,
                    borderColor: empresaSelecionada ? '#FF6A00' : '#ddd',
                    boxShadow: empresaSelecionada ? '0 0 0 2px rgba(255,106,0,.18)' : 'none',
                    '&:hover': { borderColor: '#FF6A00' }
                  }),
                  option: (base, state) => ({
                    ...base,
                    background: state.isSelected ? '#FF6A00' : state.isFocused ? 'rgba(255,106,0,.08)' : '#fff',
                    color: state.isSelected ? '#fff' : '#333',
                    fontSize: 14
                  })
                }}
              />
            </div>
            {!empresaSelecionada && (
              <span className="vx-grl-empresa-hint">
                <i className="material-icons">info</i>
                Selecione uma empresa para habilitar os módulos
              </span>
            )}
            {empresaSelecionada && (
              <span className="vx-grl-empresa-badge">
                <i className="material-icons">check_circle</i>
                {empresaSelecionada.nomeFantasia || empresaSelecionada.nome}
              </span>
            )}
          </div>

          {/* Grupos de cards */}
          <div className="vx-grl-grupos">
            {GRUPOS.map((grupo, idx) => this.renderGrupo(grupo, idx))}
          </div>

        </div>
        <ModalAlterarSenhaUsuario />
      </Autorizacao>
    )
  }
}

export function mapStateToProps (state) {
  return {
    empresas: state.empresas,
    empresaSelecionada: state.empresaSelecionada
  }
}

export default connect(mapStateToProps, {
  buscarEmpresas,
  alterarEmpresaSelecionada,
  limparViagens
})(withRouter(PaginaPrincipalGestao))
